import moment from "moment";

export function convertUTCFormat(date, format) {
  var utcDateTime = moment.utc(date);
  //console.log(utcDateTime)
  return utcDateTime.format(format);
}

export function getFormattedDate(date) {
  return moment(date).format("MM-DD-YYYY");
}

export const uniqId = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
};
